import APIClient from '@/shared/http/clients/api'

const APIPci = process.env.APIBaseURLPci
const resourceName = 'PciDic'

const GetAll = (companyId, data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}/empresa/${companyId}`, data, config)
const Get = (pciDicId, data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}/${pciDicId}`, data, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APIPci}/${resourceName}`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APIPci}/${resourceName}`, data, config)
const Delete = (pciDicId, data = {}, config = {}) => APIClient.delete(`${APIPci}/${resourceName}/${pciDicId}`, data, config)

export default {
  GetAll,
  Get,
  Create,
  Update,
  Delete
}



// WEBPACK FOOTER //
// ./src/shared/http/repositories/pci/pcidic.js